import React from "react";
import { Stack } from "@mui/material";
import { useTheme } from "@emotion/react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

// * Import kits
import Typography from "../../kit/Typography";

// * Import styles
import { accountSetupStyles } from "../../theme/style";
import { CustomisedConnector } from "../../kit/CustomisedStepConnector";

// # Component
const StepperComponent = ({
  activeStep,
  steps,
  stepper_message = "Choose the right options",
}) => {
  const theme = useTheme();
  const classes = accountSetupStyles(theme);

  // # JSX
  return (
    <>
      <Stack>
        <Typography
          sx={{
            maxWidth: "700px",
            fontWeight: theme.fontWeight[600],
            marginBottom: theme.size[20],
            color: theme.palette.cards.heading,
          }}
        >
          {stepper_message}
        </Typography>
      </Stack>
      <div style={{ width: theme.size[400] }}>
        <Stepper activeStep={activeStep} connector={<CustomisedConnector />}>
          {steps.map((label) => (
            <Step
              key={label}
              sx={(theme) => ({
                "& .MuiStepLabel-root .Mui-completed": {
                  color: theme.palette.cards.heading, // circle color (ACTIVE)
                  fontFamily: theme.typography["fontFamily"],
                },
                "& .MuiStepLabel-root .Mui-active": {
                  color: theme.palette.cards.heading, // circle color (ACTIVE)
                  fontFamily: theme.typography["fontFamily"],
                },
                "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                  {
                    color: theme.palette.grey[3], // Just text label (COMPLETED)
                    fontFamily: theme.typography["fontFamily"],
                  },
                "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                  fill: theme.palette.tertiary.light, // circle's number (ACTIVE)
                  fontFamily: theme.typography["fontFamily"],
                },
                "& .MuiStepLabel-horizontal .Mui-disabled": {
                  color: theme.palette.grey[3],
                  fill: theme.palette.grey[3],
                  fontFamily: theme.typography["fontFamily"],
                },
                "& .MuiStepLabel-iconContaine .Mui-disabled": {
                  color: theme.palette.grey[3],
                  fill: theme.palette.grey[3],
                  fontFamily: theme.typography["fontFamily"],
                },
              })}
            >
              <StepLabel
                StepIconProps={{
                  classes: { root: classes.iconVisibilityStepper },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </div>
    </>
  );
};

// # Exports
export default StepperComponent;
